import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'

import Icon from '@/components_new/Icon/Icon.vue'
import Link from '@/components_new/Link.vue'
import Typography from '@/components_new/Typography.vue'
import { LOCALE_TITLES } from '@/i18n/helpers'
import { AvailableLocale } from '@/i18n/types'

interface LocaleSwitcherProps {
    locale: AvailableLocale
    href: string
    isSelected: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LocaleSwitcher',
  props: {
    locale: {},
    href: {},
    isSelected: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const localeName = computed(() => LOCALE_TITLES[props.locale])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Link, {
    class: _normalizeClass([_ctx.$style.link, { [_ctx.$style.selected]: props.isSelected }]),
    "data-interface-target": "switch-locale",
    to: props.href,
    color: "white-60",
    disabled: props.isSelected,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click', props.locale)))
  }, {
    default: _withCtx(() => [
      _createVNode(Icon, {
        name: _ctx.locale,
        alt: `switch_to_${localeName.value}`,
        class: _normalizeClass(_ctx.$style.icon)
      }, null, 8, ["name", "alt", "class"]),
      _createVNode(Typography, {
        type: "label",
        size: "xs",
        accent: "",
        responsive: false
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(localeName.value), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class", "to", "disabled"]))
}
}

})